import { Alert, Button, Modal } from '@arco-design/web-react';
import { useEffect, useRef, useState } from 'react';
import { sourceSaveErrorMessage } from '../common/api/sourceApplicationError';
import type { FormLeavePrompt } from '../runtime/formSessionManager';

export type PortalFormLeaveRequest = Readonly<{
  input: Parameters<FormLeavePrompt>[0];
  finish: (choice: 'SAVE' | 'DISCARD' | 'CANCEL') => void;
}>;

/** Rendered by the Shell Overlay provider, outside every source application's ShadowRoot. */
export function PortalFormLeaveDialog({ request }: { request?: PortalFormLeaveRequest }) {
  const [saving, setSaving] = useState(false);
  const [failure, setFailure] = useState<string>();
  const latestRequest = useRef(request); latestRequest.current = request;
  useEffect(() => { setSaving(false); setFailure(undefined); }, [request]);
  const finish = (choice: 'SAVE' | 'DISCARD' | 'CANCEL') => {
    if (!saving && request && !request.input.signal.aborted) request.finish(choice);
  };
  const save = async () => {
    if (!request || saving || request.input.signal.aborted) return;
    const owned = request;
    setSaving(true); setFailure(undefined);
    try {
      await owned.input.save();
      if (latestRequest.current === owned && !owned.input.signal.aborted) owned.finish('SAVE');
    } catch (error) {
      if (latestRequest.current === owned && !owned.input.signal.aborted) setFailure(sourceSaveErrorMessage(error));
    } finally { if (latestRequest.current === owned && !owned.input.signal.aborted) setSaving(false); }
  };
  return <Modal visible={!!request} title="离开当前表单" alignCenter
    className="portal-form-leave-dialog" maskClosable={!saving} escToExit={!saving}
    closable={!saving} onCancel={() => finish('CANCEL')}
    footer={<>
      <Button disabled={saving} onClick={() => finish('CANCEL')}>取消切换</Button>
      <Button disabled={saving} status="danger" onClick={() => finish('DISCARD')}>放弃编辑</Button>
      <Button type="primary" loading={saving} onClick={() => void save()}>保存离开</Button>
    </>}>
    <p style={{ textAlign: 'center' }}>当前表单有未保存的编辑，是否保存后离开</p>
    {failure ? <Alert type="error" content={failure} /> : null}
  </Modal>;
}
